export const declarantDesignationOptions = [
  { value: "DIRECTOR", label: "Director" },
  { value: "SECRETARY", label: "Company Secretary" },
  { value: "MANAGER", label: "Manager" },
  { value: "ACCOUNTANT", label: "Accountant" },
];
